import { z } from "zod";

export const environmentSchema = z.object({
  aws: z.number().min(0).max(100),
  gcp: z.number().min(0).max(100),
  azure: z.number().min(0).max(100),
  other: z.number().min(0).max(100),
  onPrem: z.number().min(0).max(100),
});

export type EnvironmentFormData = z.infer<typeof environmentSchema>;

export const defaultValues: EnvironmentFormData = {
  aws: 0,
  gcp: 0,
  azure: 0,
  other: 0,
  onPrem: 0,
};
